// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchFilter_wrapper__4D33c","searchButton":"SearchFilter_searchButton__YM2bl"};